import { render, staticRenderFns } from "./InfoSnackbar.vue?vue&type=template&id=08483d11"
import script from "./InfoSnackbar.vue?vue&type=script&lang=js"
export * from "./InfoSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports